import { Col, DatePicker, Input, Row, Select, Tooltip, List } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { fieldRomaji } from './../../../../services/fieldRequired';
import { CheckFullSizeHalfSize } from './../../../../services/helper';
import { dateFormat } from './../../../../services/ruleValidate';
import './styles.css';
import { listChannel } from './../../../../utils/channel'
import hanldeException from '../../../../services/handleException';
import { orderStatus, FulfillOption as  FulfillOptionConst, terms as OriginalTerms } from '../../../../constants'
import { ListChannel as ListChannelConst} from '../../../../constants/setting_channel'
import { getFulfillmentSetting } from '../../../../utils/orders';
import Storage from '../../../../services/Storage';

const Option = Select.Option

class OrderInformationComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            listChannel: [],
            fulfillmentDefault: ''
        }
    }

    getFulfillDefault = () => {
        const { classes, order, information, pageType } = this.props
        getFulfillmentSetting().then(res => {
            if (res.data.code === 10001) {
                let fulfillmentDefault = res.data.data.FulfillmentDefault
                if (pageType !== 'editOrder') {
                    this.props.onChangeInformation({ value: fulfillmentDefault, column: 'FulfillmentOption' })
                }
            }
        })
    }

    loadChannel = () => {
        listChannel().then(res => {
            if (res.data.code === 10001) {
                let listChannel = res.data.data.channels
                if (listChannel.length && !this.props.pageType) {
                    this.props.onChangeInformation({ value: listChannel[0].Name, column: 'channel' })
                    this.props.onChangeInformation({ value: listChannel[0].ID, column: 'channel_id' })
                    this.props.onChangeInformation({ value: listChannel[0].ShortName, column: 'channel_short_name' })
                    // set class CHANNEL ORD. ITEM #
                    let { order : { items } } = this.props;
                    let ShortName = listChannel[0].ShortName;
                    for (let i = 0; i < items.length; i++) {
                        if (!items[i]['channel_order_item']) {
                            if (ShortName !== ListChannelConst.AMAZON_JP.ShortName) {
                                items[i]['classes']['channel_order_item'] = ''
                            } else {
                                items[i]['classes']['channel_order_item'] = 'error'
                            }
                        }
                    }
                    this.props.onChangeItem(items)
                }
                this.setState({
                    listChannel
                })
            } else {
                hanldeException(res)
            }
        }).catch(err => {
            hanldeException(err)
        })
    }

    onChangeDate = (value, column) => {
        let classes = this.props.classes
        if (value) {
            classes.order_date = ''
            this.props.onChangeClasses(classes)
        } else {
            value = null
            classes.order_date = 'error'
            this.props.onChangeClasses(classes)
        }

        this.props.onChangeInformation({ value, column: column })
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
        this.props.onChangeInformation({ value: new Date(value), column: 'order_date_utc' })
    }

    onChange = (value, column, maxLength) => {
        if (fieldRomaji.indexOf(column) === -1) {
            let wordMax = CheckFullSizeHalfSize(value, maxLength)
            if (!wordMax) return;
        }
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
        this.props.onChangeInformation({ value, column })
    }

    renderListChannel = () => {
        return this.state.listChannel.map((e, i) => {
            return <Option value={JSON.stringify(e)} key={i + e.ID}>{e.Name}</Option>
        })
    }

    onChangeChannel = (e) => {
        let { order : { items, shipperInformation }, information, classes } = this.props;
        let ShortName = JSON.parse(e).ShortName;
        for (let i = 0; i < items.length; i++) {
            if (!items[i]['channel_order_item']) {
                if (ShortName !== ListChannelConst.AMAZON_JP.ShortName) {
                    items[i]['classes']['channel_order_item'] = ''
                } else {
                    items[i]['classes']['channel_order_item'] = 'error'
                }
            }
        }
        this.props.onChangeItem(items)

        if (ShortName != ListChannelConst.Y_SHIP.ShortName) {
            if (!Object.keys(OriginalTerms).includes(information.terms)) {
                this.props.onChangeInformation({ value: Object.keys(OriginalTerms)[0], column: 'terms' })
            }
            if (shipperInformation.destinationCountriesCH.split(',').includes('JP')){
                this.props.onChangeInformation({value: 'JP', column:'country'})
            }else{
                this.props.onChangeInformation({value: '', column:'country'})
                classes['country'] = 'error'
                this.props.onChangeClasses(classes)
            }
        }

        this.props.onChangeInformation({ value: JSON.parse(e).Name, column: 'channel' })
        this.props.onChangeInformation({ value: JSON.parse(e).ID, column: 'channel_id' })
        this.props.onChangeInformation({ value: JSON.parse(e).ShortName, column: 'channel_short_name' })
        this.props.pageType === 'editOrder' && this.props.onChange({ value: false, column: 'buttonEditOrderDisabled' })
    }

    render() {
        const { classes, order, information, pageType } = this.props
        const FulfillmentFlg = parseInt(Storage.get('FulfillmentFlg'));
        return (
            <div>
                <div id='order-information-2'>
                    {pageType === 'editOrder' ? (
                        <React.Fragment>
                            <Row gutter={8} className="row-editOrder">
                                <Col xl={{ span: 24 }}>
                                    <div className="gutter-box item-row-edit-order">
                                        <h3 className='title-field-1'>LAST UPDATE:</h3>
                                    </div>
                                    <div className='show-last-update item-row-edit-order'>
                                        {information.last_time_update ? moment(information.last_time_update).format(dateFormat) : null}
                                    </div>
                                    <div className="gutter-box item-row-edit-order">
                                        <h3 className='title-field-1'>BY</h3>
                                    </div>
                                    <div className='show-last-update item-row-edit-order'>
                                        {information.creator_update}
                                    </div>
                                </Col>
                            </Row>
                        </React.Fragment>
                    ) : null}
                </div>
                <div id='order-information'>
                    <Row gutter={8}>
                        <Col span={24}>
                            <Row gutter={16} className="box-title-order-information">
                                <Col span={4}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>CHANNEL</h3>
                                        <Select
                                            className="select-gutter-box"
                                            value={information.channel}
                                            onChange={e => this.onChangeChannel(e)}
                                            disabled={
                                                (pageType === 'editOrder' && order.manual_flag_bl)
                                                || information.save_item
                                                || information.status_id === orderStatus.SPLIT
                                            }
                                        >
                                            {this.renderListChannel()}
                                        </Select>
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>CHANNEL ORDER #</h3>
                                        <Tooltip
                                            placement="bottomLeft"
                                            visible={order.tooltip === 'channel_order'}
                                            title={order.message}
                                            overlayClassName='tooltip-error'
                                        >
                                            <Input
                                                onChange={e => this.onChange(e.target.value, 'channel_order', 20)}
                                                maxLength={60}
                                                className={classes['channel_order'] + ' input-channel-order-info'}
                                                onBlur={e => this.props.onBlur(e.target.value, 'channel_order')}
                                                onFocus={(e) => {
                                                    this.props.validateEmpty(e.target.value, 'channel_order')
                                                    this.props.onFocus(e.target.value, 'channel_order')
                                                }}
                                                value={information.channel_order}
                                                disabled={
                                                    (pageType === 'editOrder' && order.manual_flag_bl)
                                                    || information.save_item
                                                    || information.status_id === orderStatus.SPLIT
                                                    || information.order_parent_id > 0
                                                }
                                            />
                                        </Tooltip>
                                    </div>
                                </Col>
                                <Col span={4}>
                                    <div className="gutter-box order-date">
                                        <h3 className='title-field'>ORDER DATE</h3>
                                        <DatePicker
                                            format={dateFormat}
                                            onChange={(date, dateString) => this.onChangeDate(dateString, 'order_date')}
                                            className={classes['order_date'] + " datepicker-order"}
                                            allowClear={false}
                                            disabled={
                                                (pageType === 'editOrder' && order.manual_flag_bl)
                                                || information.save_item
                                                || information.status_id === orderStatus.SPLIT
                                            }
                                            value={information.order_date ? moment(information.order_date, dateFormat) : null}
                                        />
                                    </div>
                                </Col>
                                <Col span={5}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>REF #</h3>
                                        <Input
                                            placeholder="REF"
                                            onChange={e => this.onChange(e.target.value, 'ref')}
                                            disabled
                                            value={pageType === 'editOrder' ? information.ref : ''}
                                        />
                                    </div>
                                </Col>
                                <Col span={3}>
                                    <div className="gutter-box">
                                        <h3 className='title-field'>TYPE</h3>
                                        <Input
                                            disabled
                                            value={pageType === 'editOrder' ?
                                                (order.check_type_order ? null : (!order.manual_flag_bl ? 'Manual' : (order.manual_flag_bl === 1 ? 'API Import' : 'File Import')))
                                                : 'Manual'}
                                        />
                                    </div>
                                </Col>
                                {
                                    FulfillmentFlg ?
                                    <Col span={4}>
                                        <div className="gutter-box">
                                            <h3 className='title-field'>Fulfillment Option</h3>
                                            <Select value={information.FulfillmentOption} onChange={value => this.onChange(value, 'FulfillmentOption')}  className="select-fulfillment-option-box">
                                                <Option value={FulfillOptionConst.YAMATO.CODE}>{FulfillOptionConst.YAMATO.NAME}</Option>
                                                <Option value={FulfillOptionConst.IN_HOUSE.CODE}>{FulfillOptionConst.IN_HOUSE.NAME}</Option>
                                            </Select>
                                        </div>
                                    </Col>
                                    : ''
                                }
                            </Row>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default OrderInformationComponent



// WEBPACK FOOTER //
// ./src/containers/orders/components/order-information/index.js